// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img___3rVAR","loaded":"styles_loaded___tmQIb","show":"styles_show___1RJx-","placeholderImage":"styles_placeholderImage___1n7e0","spinner":"styles_spinner___34zfW"};